<template>
  <div
    class="order-menu-v4"
    :style="{ transition: 'all 0.3s' }"
  >
    <template v-if="days.length > 0 && !loading">
      <CoreDropdown
        v-if="showPackCard"
        :show-content="packModal"
        :show-right-icon="false"
        separate-click-out-side-action
        :button-class="''"
        :button-slot-class="''"
        :mode=" $isSmartphone ? `bottom` : `select`"
        @clickOutSide="hideDropdownContent"
        @close="hideDropdownContent"
      >
        <template #default>
          <swiper
            v-if="days.length > 0 && !loading"
            ref="menuSlider"
            slides-per-view="auto"
            :free-mode="true"
            :speed="300"
            :update-on-window-resize="false"
            :space-between="16"
            class="order-menu-v4__swiper"
            @swiper="setSwiper"
          >
            <swiper-slide
              v-for="(day, dayIndex) in days"
              :key="`menu-slider-final-${dayIndex}`"
              class="order-menu-v4__slide order-menu-v4__slide--small-info"
              :class="sliderClass"
            >
              <div
                v-if="day.isEmpty"
                class="empty-days"
              >
                <div class="empty-days__title">
                  {{ day.dayOfWeek }}
                </div>
                <div class="empty-days__content">
                  Выходные исключены из вашего календаря питания
                </div>
              </div>
              <template v-else>
                <div
                  v-if="isTitleVisible"
                  class="order-menu-v4__slide-title"
                >
                  <div
                    class="order-menu-v4__slide-title-text"
                    :style="{
                      'transition-timing-function': 'ease-out',
                      'transition-duration': `${duration}ms`,
                      transform: dayIndex >= activeIndex - 1 && dayIndex <= activeIndex + 1 && transform ? transform[dayIndex]:undefined
                    }"
                  >
                    {{ day.count }} {{ $numberLingFormFunc(day.count, 'блюдо', 'блюда', 'блюд') }}
                  </div>
                </div>
                <div class="order-menu-v4__slide-content">
                  <div
                    v-for="(pack, index) in day.packs"
                    :key="`menu-slider-${index}-${dayIndex}`"
                    class="order-menu-v4__slide-inner"
                  >
                    <pack
                      v-if="pack?.id"
                      class="pack-v4--selector"
                      @click="setActivePack(pack)"
                    >
                      <template #meal>
                        <TransitionCollapse is-width>
                          <div
                            v-if="!day.customizable && selectedTemplate?.mealNumbersToRemove?.includes(pack.position)"
                            class="order-menu-v4__icon"
                          >
                            <img
                              :src="require('@/assets/images/icons/important.svg')"
                              alt=""
                            >
                          </div>
                        </TransitionCollapse>
                        <span class="order-menu-v4__text">
                          {{ pack.meal }}, {{ day.dayOfWeek }}
                        </span>
                      </template>
                      <template #ccal>
                        {{ $formatMoney(pack.ccal) }} Ккал
                      </template>
                      <template #img>
                        <Image
                          :src="pack.img"
                          :alt="pack.name"
                        />
                      </template>
                    </pack>
                    <PackEmpty
                      v-else
                      :key="`PackEmpty_${index}`"
                    >
                      <template #meal>
                        {{ pack.meal }}, {{ day.dayOfWeek }}
                      </template>
                      <template #text>
                        {{ pack.meal }} исключён из вашего календаря питания
                      </template>
                    </PackEmpty>
                  </div>
                  <div
                    class="order-menu-v4__slide-inner"
                  >
                    <packs-info>
                      <template #name>
                        всего в {{ day.dayOfWeek }}
                      </template>
                      <template #title>
                        {{ day.ccal ? `${$formatMoney(day.ccal)} Ккал`:'' }}
                      </template>
                      <template #subtitle>
                        {{ day.count }} {{ $numberLingFormFunc(day.count, 'прием', 'приема', 'приемов') }}
                      </template>
                      <template #bottom>
                        <bju :bju="day.bju" />
                      </template>
                    </packs-info>
                  </div>
                </div>
              </template>
            </swiper-slide>
          </swiper>
        </template>
        <template #content>
          <pack class="pack-v4--card">
            <template #meal>
              <bju :bju="packModal.bju" />
            </template>
            <template #ccal>
              {{ $formatMoney(packModal.ccal) }} Ккал
            </template>
            <template #img>
              <Image
                :src="packModal.img"
                :alt="packModal.name"
              />
            </template>
            <template #name>
              {{ packModal.name }}
            </template>
          </pack>
        </template>
      </CoreDropdown>
      <swiper
        v-else
        ref="menuSlider"
        slides-per-view="auto"
        :free-mode="true"
        :speed="300"
        :update-on-window-resize="false"
        :space-between="16"
        class="order-menu-v4__swiper"
        @swiper="setSwiper"
      >
        <swiper-slide
          v-for="(day, dayIndex) in days"
          :key="'menu-slider-final-'+dayIndex"
          class="order-menu-v4__slide"
          :class="sliderClass"
        >
          <div
            v-if="day.isEmpty"
            class="empty-days"
          >
            <div class="empty-days__title">
              {{ day.dayOfWeek }}
            </div>
            <div class="empty-days__content">
              Выходные исключены из вашего календаря питания
            </div>
          </div>
          <template v-else>
            <div
              v-if="isTitleVisible"
              class="order-menu-v4__slide-title"
            >
              <div
                class="order-menu-v4__slide-title-text"
                :style="{
                  'transition-timing-function': 'ease-out',
                  'transition-duration': `${duration}ms`,
                  transform: dayIndex >= activeIndex - 1 && dayIndex <= activeIndex + 1 && transform ? transform[dayIndex]:undefined
                }"
              >
                {{ day.count }} {{ $numberLingFormFunc(day.count, 'блюдо', 'блюда', 'блюд') }}
              </div>
            </div>
            <div class="order-menu-v4__slide-content">
              <div
                v-for="(pack, index) in day.packs"
                :key="`menu-slider-${index}-${dayIndex}`"
                class="order-menu-v4__slide-inner"
              >
                <pack
                  v-if="pack?.id"
                  @click="setActivePack(pack)"
                >
                  <template #meal>
                    <TransitionCollapse is-width>
                      <div
                        v-if="!day.customizable && selectedTemplate?.mealNumbersToRemove?.includes(pack.position)"
                        class="order-menu-v4__icon"
                      >
                        <img
                          :src="require('@/assets/images/icons/important.svg')"
                          alt=""
                        >
                      </div>
                    </TransitionCollapse>
                    <span class="order-menu-v4__text">
                      {{ pack.meal }}, {{ day.dayOfWeek }}
                    </span>
                  </template>
                  <template #ccal>
                    {{ $formatMoney(pack.ccal) }} Ккал
                  </template>
                  <template #img>
                    <Image
                      :src="pack.img"
                      :alt="pack.name"
                    />
                  </template>
                  <template #name>
                    {{ pack.name }}
                  </template>
                </pack>
                <PackEmpty
                  v-else
                  :key="`PackEmpty_${index}`"
                >
                  <template #meal>
                    {{ pack.meal }}, {{ day.dayOfWeek }}
                  </template>
                  <template #text>
                    {{ pack.meal }} исключён из вашего календаря питания
                  </template>
                </PackEmpty>
              </div>
              <div
                class="order-menu-v4__slide-inner order-menu-v4__slide-inner--w-auto"
              >
                <packs-info>
                  <template #name>
                    всего в {{ day.dayOfWeek }}
                  </template>
                  <template #title>
                    {{ day.ccal ? `${$formatMoney(day.ccal)} Ккал`:'' }}
                  </template>
                  <template #subtitle>
                    {{ day.count }} {{ $numberLingFormFunc(day.count, 'прием', 'приема', 'приемов') }}
                  </template>
                  <template #bottom>
                    <bju :bju="day.bju" />
                  </template>
                </packs-info>
              </div>
            </div>
          </template>
        </swiper-slide>
      </swiper>
    </template>
    <swiper
      v-else
      ref="menuSlider"
      slides-per-view="auto"
      :free-mode="true"
      :update-on-window-resize="false"
      :space-between="0"
      :speed="300"
      class="order-menu-v4__swiper"
    >
      <swiper-slide
        class="order-menu-v4__slide"
        :class="sliderClass"
      >
        <div
          v-if="isTitleVisible"
          class="order-menu-v4__slide-title"
        >
          <div
            class="order-menu-v4__slide-title-text skeleton__order-menu-v4-slide-title"
          />
        </div>
        <div class="order-menu-v4__slide-content">
          <div
            v-for="item in 4"
            :key="`order-menu-slide_${item}`"
            class="order-menu-v4__slide-inner"
          >
            <div
              class="pack-v4 skeleton__pack"
            >
              <div class="pack-v4__header">
                <span
                  class="skeleton-box radius skeleton__pack-header"
                />
              </div>
              <div
                class="pack-v4__content"
                style="width:100%;"
              >
                <div class="pack-v4__img">
                  <span
                    class="skeleton-box radius skeleton__pack-img"
                  />
                </div>
                <div
                  class="pack-v4__name"
                  style="width:100%;"
                >
                  <span
                    class="skeleton-box radius skeleton__pack-name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Pack from './Pack.vue'
import PackEmpty from './PackEmpty.vue'
import PacksInfo from './PacksInfo.vue'
import bju from './bju.vue'
import { Swiper, SwiperSlide } from 'swiper/swiper-vue'
import CoreDropdown from '@/components/core/ui/CoreDropdownV2/CoreDropdown'

import TransitionCollapse from '@/components/core/ui/TransitionCollapse.vue'

export default {
  name: 'Packs',
  components: {
    Swiper,
    SwiperSlide,
    TransitionCollapse,
    Pack,
    PackEmpty,
    PacksInfo,
    bju,
    CoreDropdown,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    selectedTemplate: {
      type: Object,
      default: null,
    },
    isTitleVisible: {
      type: Boolean,
      default: true,
    },
    days: {
      type: Array,
      default: () => [
        {
          dayOfWeek: 'пн',
          ccal: '958',
          bju: {
            b: 236,
            j: 59,
            u: 107,
          },
          packs: [
            {
              bju: {
                b: 236,
                j: 59,
                u: 107,
              },
              meal: 'завтрак',
              ccal: '351',
              name: 'Cырники творожные с курагой и клубнично-ан...',
              img: '',
            },
          ],
        },
      ],
    },
  },
  data () {
    return {
      isMounted: false,
      mySwiper: null,
      packModal: null,
    }
  },
  computed: {
    ...mapGetters({
      variationActionsDomain: 'abtesting/variationActionsDomain',
    }),
    newPackCard () {
      return this.variationActionsDomain.new_pack_card || false
    },
    showPackCard () {
      if (this.$isSmartphone && this.newPackCard) {
        return true
      }
      return false
    },
    swiper () {
      if (this.isMounted) {
        return this.$refs.menuSlider.swiper
      }
      return null
    },
    activeIndex () {
      if (this.isMounted && this.mySwiper) {
        return this.mySwiper.realIndex
      }
      return null
    },
    sliderClass () {
      return {
        'order-menu-v4__slide--small-info': this.showPackCard,
        'order-menu-v4__slide--whithout-title': !this.isTitleVisible,
      }
    },
    transform () {
      if (this.isTitleVisible && this.mySwiper?.slides) {
        // ширина слайдера (границы где он останавливается и закрепляется)
        const swiperWidth = this.mySwiper.$el[0].offsetWidth
        // смещение центра относительно слайдера
        const swiperTranslate = this.mySwiper.translate - Math.round(swiperWidth / 2)
        let slideSizeBefore = 0
        // возвращаем массив с позициями заголовков
        return this.mySwiper.slides.map((item, index) => {
          const textOffsetWidth = item.querySelector('.order-menu-v4__slide-title-text')?.offsetWidth || 0
          const textTranslate = swiperTranslate + 2 + Math.round(textOffsetWidth / 2)
          slideSizeBefore += item.swiperSlideSize + 16
          if (item.swiperSlideSize - slideSizeBefore < textTranslate) {
            // если заголовок у слайда после активного (прижимает его к левому краю слайда)
            return `translate3d(${0}px, 0px, 0px)`
          } else if (textOffsetWidth - slideSizeBefore + 36 > textTranslate) {
            // если заголовок принадлежит слайду до активного (прижимает его к правому краю слайда)
            return `translate3d(${item.swiperSlideSize - textOffsetWidth - 36}px, 0px, 0px)`
          }
          // если заголовок у активного слайда (выравнивает его по центру всего слайдера)
          return `translate3d(${item.swiperSlideSize - slideSizeBefore - textTranslate}px, 0px, 0px)`
        })
      }
      return null
    },
    duration () {
      if (this.isTitleVisible && this.mySwiper?.animating) {
        return 1000 * this.mySwiper?.params?.freeModeMomentumVelocityRatio || 0
      }
      return 0
    },
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    setSwiper (swiper) {
      this.mySwiper = swiper
    },
    hideDropdownContent () {
      this.packModal = null
    },
    setActivePack (pack) {
      this.packModal = pack
    },
  },
}
</script>

<style lang="scss">
.empty-days {
  width: 2rem;
  padding: .56rem .24rem .24rem .24rem;
  text-align: center;
  &__title {
    @include typography('b3', 'bold');
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: map-get($colors, 'secondary');
    margin-bottom: .64rem;
  }
  &__content {
    @include typography('b2', 'medium');
    color: map-get($colors, 'grey_60');
  }
}
.order-menu-v4 {
  margin: -0.04rem auto 0.24rem auto;
  width: 100%;
  padding: 0 0.16rem;
  overflow: hidden;
  &__icon {
    display: inline-block;
    height: 0.16rem;
    margin-right: .06rem;
    img {
      width: 0.24rem;
      height: 0.24rem;
      margin-top: -0.06rem;
    }
  }
  &__test {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
  }

  &__swiper {
    overflow: visible !important;
    padding-top: 0.04rem !important;
    height: fit-content !important;
    .swiper-wrapper {
      align-items: stretch;
    }
  }
  &__slide-wrapper {
    display: flex;
    width: fit-content !important;
  }
  &__slide {
    display: flex;
    flex-direction: column;
    width: max-content !important;
    height: auto !important;
    height: 2.96rem !important;
    min-height: 2.96rem !important;
    max-height: 2.96rem !important;
    padding: .10rem .08rem .08rem;
    background: map-get($colors, 'grey_8');
    border-radius: .24rem;
    position: relative;
    overflow: hidden;

    &--small-info {
      height: 2.72rem !important;
      min-height: 2.72rem !important;
      max-height: 2.72rem !important;
    }
    &--whithout-title {
      padding: .08rem !important;
      height: 2.60rem !important;
      min-height: 2.60rem !important;
    }
  }
  &__slide-title {
    position: relative;
    width: 100%;
    margin-bottom: .08rem;
  }
  &__slide-title-text {
    position: sticky;
    top: 0;
    left: .08rem;
    right: .08rem;
    width: fit-content;
    @include typography('b1', 'medium');
    color: map-get($colors, 'grey_60');
  }
  &__slide-content {
    display: flex;
    flex-wrap: wrap;
    width: max-content;
    height: 100%;
  }
  &__slide-inner {
    width: 2.48rem;
    &--w-auto {
      width: auto;
    }
    &:not(:last-child) {
      margin-right: 0.08rem;
    }
  }
  &__group {
    padding: 0.08rem 0.04rem;
    background: map-get($colors, 'grey_4');
    width: fit-content;
    height: 100%;
    border-radius: 0;
    &--start {
      padding-left: 0.08rem;
      border-top-left-radius: 0.24rem;
      border-bottom-left-radius: 0.24rem;
    }
    &--end {
      padding-right: 0.08rem;
      border-top-right-radius: 0.24rem;
      border-bottom-right-radius: 0.24rem;
    }
  }
  &__group-wrapper-spacer {
    padding-right: .16rem;
    width: fit-content;
  }
}
</style>
